/**
 * Prende una stringa e, essendo un formato mancante nel CSS, mette in maiuscolo solo la prima lettera della frase
 * @param {String} string Stringa in input
 * @returns String
 */
const CAPITALIZESTRING = (string) =>
  string
    ? string[0].toUpperCase() + string.slice(1).toLowerCase()
    : "undefined";

/**
 * Metodo che prende una data e la elabora con il nome del mese al suo interno
 * @param {String} stringDate Stringa nel formato dd/mm/yyyy
 * @returns String data nel formato dd nomeMese yyyy
 */
const CONVERTDATE = (stringDate) => {
  let arrDate = stringDate.split("/");
  return `${arrDate[0]} ${CAPITALIZESTRING(MESI[parseInt(arrDate[1])])} ${
    arrDate[2]
  }`;
};

export const MESI = [
  "",
  "gennaio",
  "febbraio",
  "marzo",
  "aprile",
  "maggio",
  "giugno",
  "luglio",
  "agosto",
  "settembre",
  "ottobre",
  "novembre",
  "dicembre",
];

/**
 * Crea una copia indipendente di un array di oggetti
 * @param {Array} objectsArray Array di oggetti che verra copiato
 * @returns Array copia indipendente dell'array di oggetti dato come parametro
 */
const COPYPOBJECTSARRAY = (objectsArray) => {
  return objectsArray.map((object) => Object.assign({}, object));
};

/**
 * Rimuove dei determinati attributi da un oggetto
 * @param {Object o Array} object Oggetto a cui rimuovere attributi, possibile anche passare un array di oggetti
 * @param {Array} entriesToRemove Array delle chiavi degli attributi da rimuovere
 * @returns Object o Array modificato
 */
const REMOVEENTRIES = (objects, entriesToRemove = []) => {
  const removeFun = (objects) =>
    objects.map((object) => {
      entriesToRemove.forEach((entry) => {
        delete object[entry];
      });
      return object;
    });

  //Per facilità porto, nel caso non mi venga passato un oggeto, l'oggetto in un array con all'interno l'oggetto
  return Array.isArray(objects) ? removeFun(objects) : removeFun([objects])[0];
};

import { getBasePath } from "../utils/env";

export const URL_APPLICATIVO = window.location.origin;
export const NOME_FILE_MANUALE_USO = `${getBasePath()}/ManualeUsoSISRMobile.pdf`;

export default {
  CAPITALIZESTRING,
  CONVERTDATE,
  COPYPOBJECTSARRAY,
  REMOVEENTRIES,
};
